// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardErrorMessage_cls1__bTsJ6","cls2":"VeloCardErrorMessage_cls2__BWiIx VeloCardErrorMessage_cls1__bTsJ6"};